/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Product_item$ref = any;
export type Product_item = {
    readonly productPhotos: ReadonlyArray<{
        readonly placeholder: string | null;
        readonly smallPath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
        } | null> | null;
    } | null> | null;
    readonly localizedPdpUrl: string | null;
    readonly " $refType": Product_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Product_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "photosLimit",
      "type": "Int",
      "defaultValue": 1
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "productPhotos",
      "name": "photos",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "placeholder",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "smallPath",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "masterOrZoomPath",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "versions",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "webPath",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedPdpUrl",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '270cec36a93197370fe2f8d168cbb28a';
export default node;
